import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { PayrollItem } from '../payroll/item/store/payroll-item.model';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PayrollItemLookupService {
    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(LoggingService) private log: LoggingService
    ) {}
    uri = `${environment.apiLocation}/PayrollItem`;

    public get(reports?: Array<string>): Observable<Array<PayrollItem>> {
        const params = {};

        this.log.verbose({
            type: 'PayrollItemLookupService:get',
            uri: this.uri,
            reports
        });
        return this.http.post<Array<PayrollItem>>(this.uri, reports).pipe(
            tap(res =>
                this.log.verbose({
                    type: 'PayrollItemLookupService:reponse',
                    res
                })
            )
        );
    }
}
